"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnnouncementsLocale = getAnnouncementsLocale;

function getAnnouncementsLocale(locale) {
  switch (locale) {
    case 'de-DE':
      return 'de';

    case 'es-ES':
      return 'es';

    case 'fr-FR':
      return 'fr';

    case 'it-IT':
      return 'it';

    case 'ja-JP':
      return 'ja';

    case 'ko-KR':
      return 'ko';

    case 'pt-BR':
      return 'pt';

    case 'zh-CN':
      return 'zh-Hans';

    case 'zh-TW':
      return 'zh-Hant';

    default:
      return 'en';
  }
}